import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Input,
  Button,
  Dropdown
} from 'semantic-ui-react'

const LandingUX = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        id="LandingUX-div-0"
        style={{ width: "100%", height: "100%" }}>
        <form
          id="LandingUX-form-13"
          onSubmit={(e: any) => { e.preventDefault();  props.loginSubmit() }}
          style={{ width: "100%", height: "100%" }}>
          <div
            id="LandingUX-div-1"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(8, 1fr)","gridTemplateColumns":"repeat(8, 1fr)"}}>
            <div
              id="LandingUX-div-11"
              style={{ display: "flex", flexDirection: "column", alignItems: "center",  gridRow: "1/8", gridColumn: "2/8",    paddingTop: "20px"}}>

              <img
                id="LandingUX-img-12"
                src={props.logo}
                style={{maxWidth: "1040px", height: "380px",...props.imgStyle}}>
              </img>
              <div
                id="LandingUX-div-14"
                style={{display: "grid", rowGap: "12px", width: "30%", marginTop: "-5px", maxWidth: "25rem"}}>

                <Input
                  id="LandingUX-Input-15"
                  name="usernameLogin"
                  onChange={props.changeUsername}
                  placeholder="username"
                  value={props.username}>
                </Input>
                <Input
                  icon={props.eye}
                  id="LandingUX-Input-16"
                  name="passwordLogin"
                  onChange={props.changePassword}
                  placeholder="password"
                  type={props.typePassword}
                  value={props.password}>
                </Input>
                <Button
                  color="teal"
                  id="LandingUX-Button-17"
                  loading={props.loading}>
                  {props.languageUX === "en" ? "Login IsHealth" : "ล๊อกอิน อิสเฮลท์"}
                </Button>
              </div>
              <div
                id="LandingUX-div-21"
                style={{width: "30%", maxWidth: "25rem"}}>
                {props.socialLogin}
              </div>
            </div>
            <div
              id="LandingUX-div-18"
              style={{ gridRow: "1/2", gridColumn: "7/8"}}>
              <div
                id="LandingUX-div-19"
                style={{margin:"20px", width: "100px"}}>

                <Dropdown
                  fluid={true}
                  id="LandingUX-Dropdown-20"
                  onChange={props.onChangeSelectedLanguage}
                  options={props.languageOptions}
                  selection={true}
                  style={{backgroundColor: "#00e4ff"}}
                  value={props.selectedLanguage}>
                </Dropdown>
              </div>
            </div>
          </div>
        </form>
      </div>
    )
}


export default LandingUX

export const screenPropsDefault = {}

/* Date Time : Mon Aug 25 2025 12:45:50 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "LandingUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "label": "divgrid",
      "name": "div",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "LandingUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(8, 1fr)\",\"gridTemplateColumns\":\"repeat(8, 1fr)\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "LandingUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flexDirection: \"column\", alignItems: \"center\",  gridRow: \"1/8\", gridColumn: \"2/8\",    paddingTop: \"20px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "img",
      "parent": 11,
      "props": {
        "id": {
          "type": "value",
          "value": "LandingUX-img-12"
        },
        "src": {
          "type": "code",
          "value": "props.logo"
        },
        "style": {
          "type": "code",
          "value": "{maxWidth: \"1040px\", height: \"380px\",...props.imgStyle}"
        }
      },
      "seq": 12,
      "void": true
    },
    {
      "from": null,
      "id": 13,
      "name": "form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "LandingUX-form-13"
        },
        "onSubmit": {
          "type": "code",
          "value": "(e: any) => { e.preventDefault();  props.loginSubmit() }"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "LandingUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", rowGap: \"12px\", width: \"30%\", marginTop: \"-5px\", maxWidth: \"25rem\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Input",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "LandingUX-Input-15"
        },
        "name": {
          "type": "value",
          "value": "usernameLogin"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeUsername"
        },
        "placeholder": {
          "type": "value",
          "value": "username"
        },
        "value": {
          "type": "code",
          "value": "props.username"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Input",
      "parent": 14,
      "props": {
        "icon": {
          "type": "code",
          "value": "props.eye"
        },
        "id": {
          "type": "value",
          "value": "LandingUX-Input-16"
        },
        "name": {
          "type": "value",
          "value": "passwordLogin"
        },
        "onChange": {
          "type": "code",
          "value": "props.changePassword"
        },
        "placeholder": {
          "type": "value",
          "value": "password"
        },
        "type": {
          "type": "code",
          "value": "props.typePassword"
        },
        "value": {
          "type": "code",
          "value": "props.password"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "ล๊อกอิน อิสเฮลท์",
          "valueEN": "Login IsHealth"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "LandingUX-Button-17"
        },
        "loading": {
          "type": "code",
          "value": "props.loading"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "LandingUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"7/8\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "LandingUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"20px\", width: \"100px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Dropdown",
      "parent": 19,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "LandingUX-Dropdown-20"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeSelectedLanguage"
        },
        "options": {
          "type": "code",
          "value": "props.languageOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"#00e4ff\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedLanguage"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.socialLogin"
        },
        "id": {
          "type": "value",
          "value": "LandingUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{width: \"30%\", maxWidth: \"25rem\"}"
        }
      },
      "seq": 21,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "LandingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
